module.exports = __webpack_public_path__ + "img/20221208110637972bxn.b57485a9.png";